'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactOnclickoutside = require('react-onclickoutside');

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _popupMenuLocal = require('./popup-menu.local.css');

var _popupMenuLocal2 = _interopRequireDefault(_popupMenuLocal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var PopupMenu = function (_Component) {
  _inherits(PopupMenu, _Component);

  function PopupMenu() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PopupMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PopupMenu.__proto__ || Object.getPrototypeOf(PopupMenu)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickOutside = function () {
      if (_this.props.visible) {
        _this.props.hide();
      }
    }, _this.handleClick = function (ev) {
      ev.preventDefault();

      if (_this.props.visible && _this.props.closeOnClick) {
        return _this.props.hide();
      }

      return _this.props.onClick();
    }, _this.renderPopup = function () {
      var _this$props = _this.props,
          align = _this$props.align,
          visible = _this$props.visible,
          children = _this$props.children,
          theme = _this$props.theme;

      if (!visible) {
        return null;
      }

      return _react2.default.createElement('div', {
        className: (0, _classnames2.default)(_popupMenuLocal2.default.popup, _popupMenuLocal2.default['popup--' + align], _popupMenuLocal2.default['popup--' + theme]),
        'data-auto': 'popup-list'
      }, _react2.default.createElement('div', {
        className: (0, _classnames2.default)(_popupMenuLocal2.default.popupArrow, _popupMenuLocal2.default['popupArrow--' + align])
      }), _react2.default.createElement('ul', {
        className: _popupMenuLocal2.default.popupLinks
      }, children));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PopupMenu, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          icon = _props.icon,
          iconColor = _props.iconColor,
          iconSize = _props.iconSize,
          iconRotation = _props.iconRotation,
          text = _props.text,
          toggleClassName = _props.toggleClassName,
          visible = _props.visible,
          customToggleComponent = _props.customToggleComponent;
      var commonButtonProps = {
        'data-auto': 'popup-toggle',
        'aria-haspopup': 'true',
        'aria-expanded': visible
      };
      return _react2.default.createElement('div', {
        className: _popupMenuLocal2.default.popupContainer
      }, customToggleComponent ? _react2.default.cloneElement(customToggleComponent, _extends({
        onClick: this.handleClick
      }, commonButtonProps)) : _react2.default.createElement('button', _extends({
        className: (0, _classnames2.default)(_popupMenuLocal2.default.popupToggle, toggleClassName),
        onClick: this.handleClick,
        'aria-label': 'Toggle Menu'
      }, commonButtonProps), _react2.default.createElement('div', {
        className: _popupMenuLocal2.default.popupButtonInner
      }, icon ? _react2.default.createElement(_icon2.default, {
        icon: icon,
        color: iconColor,
        size: iconSize,
        rotate: iconRotation,
        className: _popupMenuLocal2.default.icon
      }) : null, text ? _react2.default.createElement('span', {
        className: _popupMenuLocal2.default.popupText
      }, text) : null)), this.renderPopup());
    }
  }]);

  return PopupMenu;
}(_react.Component);

PopupMenu.propTypes = {
  visible: _propTypes2.default.bool.isRequired,
  onClick: _propTypes2.default.func.isRequired,
  hide: _propTypes2.default.func.isRequired,
  text: _propTypes2.default.string,
  icon: _propTypes2.default.string,
  iconColor: _propTypes2.default.string,
  iconSize: _propTypes2.default.string,
  iconRotation: _propTypes2.default.number,
  closeOnClick: _propTypes2.default.bool,
  children: _propTypes2.default.node.isRequired,
  toggleClassName: _propTypes2.default.string,

  /**
   * A custom component to be used as the toggle button
   */
  customToggleComponent: _propTypes2.default.element,
  align: _propTypes2.default.oneOf(['left', 'center', 'right']),
  theme: _propTypes2.default.oneOf(['light', 'dark'])
};
PopupMenu.defaultProps = {
  icon: 'more',
  text: null,
  iconColor: 'dark',
  iconSize: 'medium',
  closeOnClick: true,
  align: 'right',
  theme: 'dark'
};
exports.default = (0, _reactOnclickoutside2.default)(PopupMenu);